export default __webpack_public_path__ + "static/media/Baby12.fe3c0760.gif";